import type { SearchHit } from "./types";

/**
 * Where a search result navigates. The backend returns ids only; routing lives
 * here so the API stays decoupled from frontend paths. Record types jump into
 * the owning client's sub-page.
 */
export function resultHref(hit: SearchHit): string {
  switch (hit.type) {
    case "client":
      return `/client/${hit.id}/overview`;
    case "document":
      return `/client/${hit.clientId}/documents`;
    case "case":
      return `/client/${hit.clientId}/cases/${hit.id}`;
    case "invoice":
      return `/client/${hit.clientId}/invoices/${hit.id}`;
    case "notice":
      return `/client/${hit.clientId}/irs-notices/${hit.id}`;
    // No per-practitioner detail route exists — land on the list (intentional).
    case "practitioner":
      return "/practitioners";
    // The backend returns a KB id, but wiki detail is slug-based and FAQ has no
    // detail page, so we land on the KB home (intentional; revisit if the API
    // starts returning a slug).
    case "faq":
    case "wiki":
      return "/kb";
    default:
      return "/search";
  }
}
